export default __webpack_public_path__ + "static/media/instagram_message.7ead3bf9.svg";